import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import UploadIcon from '@wix/da-ds/pkg/Icons/24x24/Upload';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import { getIsRootStashFolder } from '../../../../selectors/studio';
import { getHasSubfolders } from '../../../../selectors/stash';
import { illustrationUrl } from '../../StudioBlankSlate';
import UploadBlankSlate from '../../_partials/UploadBlankSlate';

const STASH_IMG_URL = illustrationUrl('studio-stash-empty.png', 2);

const StashBlankSlate: FC<{}> = () => {
  const { t } = useTranslation();
  const isRootStashFolder = useSelector(getIsRootStashFolder);
  const hasSubfolders = useSelector(getHasSubfolders);
  return isRootStashFolder && !hasSubfolders ? (
    <UploadBlankSlate
      title={t('studio.blankSlate.dropzone.stash.title')}
      subtitle={t('studio.blankSlate.dropzone.stash.subtitle')}
      ctaLabel={t('studio.blankSlate.dropzone.stash.ctaLabel')}
      illustrationSrc={STASH_IMG_URL}
    />
  ) : (
    <UploadBlankSlate
      title={t('studio.blankSlate.dropzone.stash.titleNotEmpty')}
      customIllustration={<UploadIcon size={IconSize.MEDIUM} />}
    />
  );
};
StashBlankSlate.displayName = 'StashBlankSlate';

export default StashBlankSlate;
